<template>
  <v-container fluid>
    <v-layout
      v-if="groupsLoading"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex>
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <div v-if="hasGroups">
        <v-flex>
          <h1>{{ strings.outstanding }}</h1>
        </v-flex>
        <v-flex
          v-for="group in groups"
          :key="group.id"
        >
          <v-list>
            <v-list-group
              prepend-icon="mdi-view-dashboard"
              value="false"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>{{ group.name }}</v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-tile
                v-for="(poi, index) in group.pois"
                :key="index"
              >
                <v-flex>
                  {{ poi.name }}
                  <v-btn
                    class="float-right"
                    color="primary"
                    @click="assignPoiClicked(poi)"
                  >
                    Assign
                  </v-btn>
                </v-flex>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-flex>
      </div>
      <div v-else>
        <v-flex>
          <h3>{{ strings.noPointsofInteresttoshow }}</h3>
        </v-flex>
      </div>
    </v-layout>
    <AreYouSure
      v-model="areYouSureAssign"
      action="assigning this POI"
      @answer="onCompleteAnswer($event)"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AreYouSure from '../components/AreYouSure.vue';
export default {
  components: { AreYouSure },
  data() {
    return {
      selectedPoi: null,
      areYouSureAssign: false
    }
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    ...mapGetters("group", ["groupsLoading", "allGroups"]),
    groups() {
      return this.allGroups.filter(l => l.pois.length > 0);
    },
    hasGroups() {
      return this.groups.length > 0;
    }
  },
  methods: {
    assignPoiClicked(poi) {
      this.selectedPoi = poi;
      this.areYouSureAssign = true;
    },
    onCompleteAnswer(answer) {
      if(answer) {
        this.$store.dispatch("poi/AssignPoi", this.selectedPoi)
        .then(res => {
          this.areYouSureAssign = false;
        })
      }
      else {
        this.areYouSureAssign = false;
      }
    }
  }
}
</script>

<style scoped>

</style>